// =====================================================
// TRANSLATIONS - English & Spanish
// =====================================================

export const translations = {
  en: {
    // App
    appName: "ProEstiMate",
    appTagline: "Professional Construction Estimates",
    
    // Navigation
    dashboard: "Dashboard",
    newEstimate: "New Estimate",
    estimates: "Estimates",
    settings: "Settings",
    back: "Back",
    refresh: "Refresh",
    
    // Dashboard Stats
    totalEstimates: "Total Estimates",
    draft: "Draft",
    sent: "Sent",
    accepted: "Accepted",
    rejected: "Rejected",
    invoiced: "Invoiced",
    totalValue: "Total Value",
    
    // Estimate Builder
    clientInformation: "Client Information",
    clientName: "Client Name",
    address: "Address",
    phone: "Phone",
    email: "Email",
    
    insuranceInformation: "Insurance Information",
    claimNumber: "Claim #",
    policyNumber: "Policy #",
    dateOfLoss: "Date of Loss",
    causeOfLoss: "Cause of Loss",
    
    projectInformation: "Project Information",
    jobNumber: "Job Number",
    projectType: "Project Type",
    
    // Project Description
    projectDescription: "Project Description",
    scopeOfWork: "Scope of Work",
    projectDescriptionPlaceholder: "Describe the project scope in detail...",
    projectDescriptionHint: "Provide a detailed description of the project scope, materials, and specifications.",
    
    generalFees: "General Fees",
    permitFees: "Permit Fees",
    dumpsterFees: "Dumpster Fees",
    cleaningFees: "Cleaning Fees",
    
    lineItems: "Line Items",
    fromLibrary: "Add from Library",
    custom: "Add Custom Item",
    searchLibrary: "Search Line Item Library",
    searchPlaceholder: "Search by title, description, or project type...",
    noTemplates: "No templates found.",
    addAll: "Add All",
    add: "Add",
    
    taxRate: "Tax Rate (%)",
    subtotal: "Subtotal",
    tax: "Tax",
    grandTotal: "Grand Total",
    
    termsAndConditions: "Terms and Conditions",
    estimatePreview: "Estimate Preview",
    constructionEstimate: "CONSTRUCTION ESTIMATE",
    
    // Actions
    save: "Save",
    saveEstimate: "Save Estimate",
    exportPdf: "Export PDF",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    
    // Status
    status: "Status",
    date: "Date",
    amount: "Amount",
    actions: "Actions",
    
    // Messages
    estimateCreated: "Estimate created!",
    estimateUpdated: "Estimate updated!",
    estimateDeleted: "Estimate deleted",
    itemsAdded: "items added",
    clientRequired: "Client name is required",
    
    // Signatures
    clientSignature: "Client Signature",
    contractorSignature: "Contractor Signature",
    
    // Project Types
    kitchenRemodel: "Kitchen Remodel",
    bathroomRemodel: "Bathroom Remodel",
    homeAddition: "Home Addition",
    newConstruction: "New Construction",
    poolConstruction: "Pool Construction",
    roofReplacement: "Roof Replacement",
    garageConversion: "Garage Conversion",
    plumbing: "Plumbing / Leak Detection",
    hvac: "HVAC Services",
    moldRemediation: "Mold Remediation",
    flooring: "Flooring",
    painting: "Painting",
    generalRenovation: "General Renovation",
  },
  
  es: {
    // App
    appName: "ProEstiMate",
    appTagline: "Presupuestos Profesionales de Construcción",
    
    // Navigation
    dashboard: "Panel",
    newEstimate: "Nuevo Presupuesto",
    estimates: "Presupuestos",
    settings: "Configuración",
    back: "Volver",
    refresh: "Actualizar",
    
    // Dashboard Stats
    totalEstimates: "Total de Presupuestos",
    draft: "Borrador",
    sent: "Enviado",
    accepted: "Aceptado",
    rejected: "Rechazado",
    invoiced: "Facturado",
    totalValue: "Valor Total",
    
    // Estimate Builder
    clientInformation: "Información del Cliente",
    clientName: "Nombre del Cliente",
    address: "Dirección",
    phone: "Teléfono",
    email: "Correo Electrónico",
    
    insuranceInformation: "Información del Seguro",
    claimNumber: "# de Reclamo",
    policyNumber: "# de Póliza",
    dateOfLoss: "Fecha de Pérdida",
    causeOfLoss: "Causa de Pérdida",
    
    projectInformation: "Información del Proyecto",
    jobNumber: "Número de Trabajo",
    projectType: "Tipo de Proyecto",
    
    // Project Description
    projectDescription: "Descripción del Proyecto",
    scopeOfWork: "Alcance del Trabajo",
    projectDescriptionPlaceholder: "Describa el alcance del proyecto en detalle...",
    projectDescriptionHint: "Proporcione una descripción detallada del alcance del proyecto, materiales y especificaciones.",
    
    generalFees: "Tarifas Generales",
    permitFees: "Tarifas de Permisos",
    dumpsterFees: "Tarifas de Contenedor",
    cleaningFees: "Tarifas de Limpieza",
    
    lineItems: "Partidas",
    fromLibrary: "Agregar de Biblioteca",
    custom: "Agregar Partida Personalizada",
    searchLibrary: "Buscar en Biblioteca de Partidas",
    searchPlaceholder: "Buscar por título, descripción o tipo de proyecto...",
    noTemplates: "No se encontraron plantillas.",
    addAll: "Agregar Todo",
    add: "Agregar",
    
    taxRate: "Tasa de Impuesto (%)",
    subtotal: "Subtotal",
    tax: "Impuesto",
    grandTotal: "Total General",
    
    termsAndConditions: "Términos y Condiciones",
    estimatePreview: "Vista Previa del Presupuesto",
    constructionEstimate: "PRESUPUESTO DE CONSTRUCCIÓN",
    
    // Actions
    save: "Guardar",
    saveEstimate: "Guardar Presupuesto",
    exportPdf: "Exportar PDF",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    
    // Status
    status: "Estado",
    date: "Fecha",
    amount: "Monto",
    actions: "Acciones",
    
    // Messages
    estimateCreated: "¡Presupuesto creado!",
    estimateUpdated: "¡Presupuesto actualizado!",
    estimateDeleted: "Presupuesto eliminado",
    itemsAdded: "partidas agregadas",
    clientRequired: "El nombre del cliente es requerido",
    
    // Signatures
    clientSignature: "Firma del Cliente",
    contractorSignature: "Firma del Contratista",
    
    // Project Types
    kitchenRemodel: "Remodelación de Cocina",
    bathroomRemodel: "Remodelación de Baño",
    homeAddition: "Ampliación de Casa",
    newConstruction: "Nueva Construcción",
    poolConstruction: "Construcción de Piscina",
    roofReplacement: "Reemplazo de Techo",
    garageConversion: "Conversión de Garaje",
    plumbing: "Plomería / Detección de Fugas",
    hvac: "Servicios de HVAC",
    moldRemediation: "Remediación de Moho",
    flooring: "Pisos",
    painting: "Pintura",
    generalRenovation: "Renovación General",
  }
};

export default translations;
